import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AmIconModule } from '../am-icon/am-icon.module';
import { ThemeStorageService } from '../theme-storage.service';
import { ThemeToggleModule } from '../theme-toggle/theme-toggle.module';
import { AppNavComponent } from './app-nav.component';
import { AppNavSubmenuComponent } from '../app-nav-submenu/app-nav-submenu.component';

@NgModule({
  declarations: [AppNavComponent, AppNavSubmenuComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    AmIconModule,
    MatMenuModule,
    ThemeToggleModule,
    RouterModule,
  ],
  exports: [AppNavComponent, AppNavSubmenuComponent],
  providers: [ThemeStorageService],
})
export class AppNavModule {}
